import axios from 'axios'


export default {
    checkResponse(response) {
        if (response) {
            if (!!response.data.deactivated) {
                if (window.location.pathname != '/login') {
                    return window.location.href = '/login';
                }
            } else {
                return response.data
            }
        } else {
            toastr['error']('Ошибка', 'Ошибка');

            return window.location.href = '/login';
        }
    },
    getCountries() {

        return axios.get('/countries')
            .then(response => {

                return this.checkResponse(response)
            })
    },
    getAffisePlatforms() {

        return axios.get('/offers/affise-platforms')
            .then(response => {

                return this.checkResponse(response)
            })
    },
    getPlatforms() {

        return axios.get('/offers/platforms')
            .then(response => {

                return response.data;
            })
    },
    getTrackers() {

        return axios.get('/offers/trackers')
            .then(response => {

                return this.checkResponse(response)
            })
    },
    getTopics() {

        return axios.get('/offers/topics')
            .then(response => {

                return this.checkResponse(response)
            })
    },
    getCurrency() {

        return axios.get('/currency')
            .then(response => {

                return this.checkResponse(response)
            })
    },
    searchOffer(id, affisePlatform) {

        return axios.get('/offers/affise-offer?affiseId=' + id + '&affisePlatform=' + affisePlatform)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    getAdvertiser(id, affisePlatform) {

        return axios.get('/offers/advertiser?id=' + id + '&affisePlatform=' + affisePlatform)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    saveOffer(offer) {

        return axios.post('/offers/save', offer)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    updateOffer(offer) {

        return axios.post('/offers/update/' + offer.id, offer)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    deleteOffer(id) {

        return axios.post('/offers/delete/' + id)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    getOffers(page, sort, search, range, user, isAllPages, geo, pageSize, advertisers = [], types = []) {
        var url =
          '/offers/list?page=' + page + '&sortBy=' + sort.sortBy + '&sortDesc=' + sort.sortDesc
          + '&start=' + range.start + '&end=' + range.end + '&user=' + user
          + '&advertisers=' + advertisers + '&search=' + search + '&allPages=' + isAllPages
          + '&geo=' + geo + '&types=' + types + '&pageSize=' + pageSize;

        return axios.get(url)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    getDataSelectOffers(page, sort, search, range, user, isAllPages, geo, pageSize) {
        var url = '/offers/select-list?page=' + page + '&sortBy=' + sort.sortBy + '&sortDesc=' + sort.sortDesc + '&start=' + range.start + '&end=' + range.end + '&user=' + user + '&search=' + search + '&allPages=' + isAllPages + '&geo=' + geo + '&pageSize=' + pageSize;

        return axios.get(url)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    getUsers() {

        return axios.get('/users/get')
            .then(response => {

                return this.checkResponse(response)
            })
    },
    getAccounts() {

        return axios.get('/users/role/get?role=account')
            .then(response => {

                return this.checkResponse(response)
            })
    },
    getLeaderUsers() {
        return axios.get('/users/leader')
            .then(response => {

                return this.checkResponse(response)
            })
    },
    changeRate(offersIds, rate) {
        return axios.post('/data/lead-rate', {
            'ids': offersIds,
            'rate': rate
        })
            .then(response => {

                return this.checkResponse(response)
            })
    },
    getSourcesForSelect() {
        return axios.get('/sources/select-list')
            .then(response => {

                return this.checkResponse(response)
            })
    },
    massChangeOfferAdvertiser(offerIds, advertiserId) {
      return axios.post('/offers/mass-update', {
        offerIds: offerIds,
        advertiserId: advertiserId
      })
        .then(response => response)
        .catch(e => e.response)
        .then(response => this.checkResponse(response))
    },
}



// WEBPACK FOOTER //
// ./resources/js/services/offersDataService.js